module.exports = __webpack_public_path__ + "static/media/screen-org-projects-archived.bbf5024c.jpg";